// Marcas disponibles para publicar y filtrar vehículos
const Marcas = [
  "Alfa Romeo",
  "Audi",
  "BMW",
  "Chevrolet",
  "Dodge",
  "Ferrari",
  "Fiat",
  "Ford",
  "Honda",
  "Hyundai",
  "Jeep",
  "Mercedez Benz",
  "Reanult",
  "Volkswagen",
];

export default Marcas;
